// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"594e01f7","977":"6dc3f625"}[chunkId] + ".chunk.js";
};